import React, { useState } from "react";
import { ResponseRecommendation } from "@lib/ShiOneClient"; import {   Box, Button, Checkbox, Link, ListItem, ListItemText, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import { NavLink } from "react-router-dom";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import ColoredChips from "shared-ui/src/theme/extensions/ColoredChips";
import { impactColor } from "@features/assessments-feature/utils/assessmentsColors";
import { SkeletonWrapper } from "shared-ui";
import { fourLineHeightCell } from "../../../../theme/mixins/lineHeight";
import ProductLogosList from "@features/assessments-feature/components/priorities-recommendations/ProductLogosList";
import HarveyBall from "@features/assessments-feature/components/spr-harveyball/HarveyBall";
import { useAssessmentExportContext } from "@features/assessments-feature/contexts-providers/AssessmentExportContextProvider";
import { useAssessmentViewContext } from "@features/assessments-feature/contexts-providers/AssessmentViewContextProvider";
import { AppendIfPrefixExists } from "../../../../../../modules/sitePaths";

const ImpactsAndRecsItem = ({
  loading,
  recData,
  handleRecsDialogOpenState,
}: {
  loading: boolean;
  recData?: ResponseRecommendation;
  handleRecsDialogOpenState: (
    recsValue: ResponseRecommendation | undefined,
    openState: boolean,
  ) => void;
}) => {
  const theme = useTheme();
  const { isPrint } = useAssessmentExportContext();
  const { selectedSourceIds, handleCheckRecommendation } =
    useAssessmentViewContext();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <ListItem divider>
        <Grid container alignItems={"center"} spacing={1}>
          <Grid item>
            <Checkbox
              color={"secondary"}
              checked={selectedSourceIds.has(
                `${recData?.assessmentId}:${recData?.recommendationId}`,
              )}
              disabled={recData?.isLinkedToRoadmap}
              onChange={(event) => handleCheckRecommendation(event, recData)}
            />
          </Grid>
          {recData?.impact && (
            <Grid item md={"auto"} pr={1.5}>
              <SkeletonWrapper loading={loading}>
                <ColoredChips
                  borderColor={impactColor[recData?.impact?.toLowerCase()]}
                  label={recData.impact}
                />
              </SkeletonWrapper>
            </Grid>
          )}
          <Grid item md={6}>
            <SkeletonWrapper loading={loading}>
              <ListItemText
                primary={
                  <Link
                    sx={{ cursor: "pointer" }}
                    variant={"body1"}
                    onClick={() => handleRecsDialogOpenState(recData, true)}
                  >
                    {!!recData?.capability ? recData?.capability : "N/A"}
                  </Link>
                }
                secondary={recData?.recommendationsSummary}
                slotProps={{
                  secondary: {
                    component: "div",
                    sx: fourLineHeightCell,
                  }
                }}
              />
              {recData?.isLinkedToRoadmap &&
                recData?.initiativeId &&
                recData?.roadmapId && (
                  <Box display="flex" alignItems="center">
                    <SubdirectoryArrowRightIcon
                      sx={{
                        color: theme.palette.text.secondary,
                        m: 1,
                      }}
                    />
                    <NavLink
                      target={"_blank"}
                      style={{ textDecoration: "none" }}
                      to={AppendIfPrefixExists(
                        `/roadmaps/${recData.roadmapId}?initiativeId=${recData.initiativeId}`,
                      )}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          color: theme.palette.primary.main,
                          "&:visited": { color: theme.palette.primary.main },
                        }}
                      >
                        {`${recData.roadmapName ?? ""} → ${recData.initiativeName ?? ""}`}
                      </Typography>
                    </NavLink>
                  </Box>
                )}
            </SkeletonWrapper>
          </Grid>
          <Grid item xs={12} md width={"100%"}>
            <ProductLogosList
              toolsLogos={recData?.otherToolsLogos}
              tools={recData?.otherTools}
              sx={{ justifyContent: "center" }}
            />
          </Grid>
          {!isPrint && (
            <Grid item container justifyContent="end" xs={12} md={2}>
              {recData?.hasHarveyBallData && (
                <div>
                  <Button variant={"text"} onClick={() => setIsOpen(true)}>
                    Compare Solutions
                  </Button>
                  <HarveyBall
                    actionTitle={recData?.capability ?? ""}
                    capabilityId={recData?.capabilityId ?? ""}
                    open={isOpen ?? false}
                    setIsOpen={setIsOpen}
                  />
                </div>
              )}
            </Grid>
          )}
        </Grid>
      </ListItem>
    </div>
  );
};

export default ImpactsAndRecsItem;
